export enum ImportEvent {
	DataImport = 'DataImport',
	DataSourceImport = 'DataSourceImport',
	UserInviteImport = 'UserInviteImport',
	UserImport = 'UserImport',
	Other = 'Other'
}

export interface DataImportDialogDataModel{
	title?: string;
	copy?: string;
	primaryButtonText?: string;
	showSecondaryButton?: boolean;
	secondaryButtonText?: string;
	showCancelButton?: boolean;
	cancelButtonText?: string;
	showDialogCloseButton?: boolean;
	multipleFiles?: boolean;
	uploadAccept?: string;
	dropAreaTitle?: string;
	dropAreaCopy?: string;
	businessId?: string;
	event: ImportEvent;
	onCheckFile?: (file: File) => Promise<File>;
	showTemplateDownloadButton?: boolean;
	onDownloadTemplate?: () => void;
}
